import fetch from"./fetch";export default{info:{key:"node",title:"Node.js",extname:".js",default:"fetch"},fetch:fetch};
//# sourceMappingURL=index.js.map